import noop from 'lodash/noop'
import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

type DisposeFn = () => void

export class DoOnConnecting<V = any, E = any, C = any> extends Pass<V, E, C> {
    protected dispose: DisposeFn = noop
    constructor(
        protected onConnecting: (stream: Stream<V, E, C>) => DisposeFn | void,
        source?: AnySourceStream<V, E, C>
    ) {
        super(source)
    }

    connect() {
        this.dispose = this.onConnecting(this) || noop
        super.connect()
    }

    disconnect() {
        super.disconnect()
        this.dispose()
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        doOnConnecting<T>(
            onConnecting: (stream: Stream<DV, DE, DC>) => DisposeFn | void
        ): Stream<DV, DE, DC, DV, DE, DC>
    }
}

Stream.prototype.doOnConnecting = function <DV, DE, DC>(
    this: AnySourceStream<DV, DE, DC>,
    onSubscription: (stream: Stream<DV, DE, DC>) => DisposeFn | void
) {
    return new DoOnConnecting(onSubscription, this) // tslint:disable-line:no-invalid-this
}
